export const formatINR = (amount, type = "buy") => {
  if (amount == null) return "—";
  if (type === "rent") {
    if (amount >= 100000) return `₹${(amount / 100000).toFixed(2)} L/mo`;
    return `₹${amount.toLocaleString("en-IN")}/mo`;
  }
  if (amount >= 10000000) return `₹${(amount / 10000000).toFixed(2)} Cr`;
  if (amount >= 100000) return `₹${(amount / 100000).toFixed(1)} L`;
  return `₹${amount.toLocaleString("en-IN")}`;
};

export const formatSqft = (n) => (n == null ? "—" : `${n.toLocaleString("en-IN")} sq.ft`);

export const formatApiError = (detail) => {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  if (detail && typeof detail.message === "string") return detail.message;
  return String(detail);
};
